import { AccessAction, AccessResource } from "@/shared/access-control/access-control";
import { createRouteFromRouteElements } from "@/shared/environment/ability-route-helper";
import { Ability, NavigationMenuEntry, Route, RouteElementWithParam } from "@/shared/environment/ability.types";
import { keyText } from "@/shared/i18n/translation-types";
import { DATA_PROCESS_ALIAS } from "./constants";

export class DataProcessAbility implements Ability {
    alias = DATA_PROCESS_ALIAS;

    getNavigationMenuEntries = (): Array<NavigationMenuEntry> => [
        {
            icon: "fa-regular fa-cloud-arrow-up",
            title: keyText("data-process.Imports"),
            internalRoute: {
                alias: DATA_PROCESS_ALIAS,
            },
        },
    ];

    getRoutes = (): Array<Route> => [
        {
            alias: DATA_PROCESS_ALIAS,
            params: [],
            isRoot: true,
            getComponent: () => import("../pages/data-process-main.vue"),
            access: {
                accessAction: AccessAction.write,
                accessResource: AccessResource.data_ingest_data,
            },
            getBreadCrumbs: (
                parentElements: Array<RouteElementWithParam>,
                currentElement: RouteElementWithParam,
                translateMethod: (text: string) => string
            ) => {
                return [
                    {
                        content: {
                            simpleText: translateMethod("data-process.Data processes"),
                        },
                        getRouterTo: () => createRouteFromRouteElements(parentElements, currentElement),
                    },
                ];
            },
        },
    ];
}
